import { SelectSearch } from '@/components/features/shared/SelectSearch'
import { CreateAgreementData } from '@/domain/agreements/agreement'
import { UserStatus } from '@/domain/auth/auth'
import { useClient, useClients } from '@/hooks/api/useClients'
import { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'

interface ParcelClientSelectorProps {
  form: ReturnType<typeof useForm<CreateAgreementData>>
}

export const ParcelClientSelector = ({
  form,
}: ParcelClientSelectorProps) => {
  const [clientSearch, setClientSearch] = useState('')

  const clientFilters = useMemo(
    () => ({ search: clientSearch, status: UserStatus.Active }),
    [clientSearch],
  )

  const { data: clientsResponse } = useClients(clientFilters)
  const clients = clientsResponse?.data
  const selectedUserId = form.watch('userId')
  const { data: selectedClient } = useClient(selectedUserId)

  const clientItems = useMemo(
    () => [
      ...(clients || [])
        .filter((client) => client.id !== selectedClient?.id)
        .map((client) => ({
          id: client.id,
          label: `${client.name} - N° ${client.code}`,
        })),
      ...(selectedClient
        ? [
            {
              id: selectedClient.id,
              label: `${selectedClient.userData.legalName} - N° ${selectedClient.userData.code}`,
            },
          ]
        : []),
    ],
    [clients, selectedClient?.id]
  )

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium">Cliente</label>
        <SelectSearch
          value={form.watch('userId')}
          onValueChange={(value) => form.setValue('userId', value)}
          onSearchChange={setClientSearch}
          placeholder="Seleccione un cliente"
          searchPlaceholder="Buscar cliente..."
          emptyMessage="No se encontraron clientes."
          items={clientItems}
        />
        {form.formState.errors.userId && (
          <p className="text-sm text-red-500">{form.formState.errors.userId?.message}</p>
        )}
      </div>
    </div>
  )
}
